import DatePicker from "@rio-cloud/rio-uikit/DatePicker";
import moment from "moment";

type DueDateFieldProps = {
  className: string;
  label: string;
  placeholder: string;
  momentLocale: string;
  value?: string;
  errorMessage?: string;
  onChange: (value: string) => void;
};

const DueDateField = ({
  className,
  label,
  placeholder,
  momentLocale,
  value,
  errorMessage,
  onChange,
}: DueDateFieldProps) => (
  <div className={`${className} ${errorMessage ? "has-feedback has-error" : ""}`}>
    <label htmlFor="inputDueDate">{label}</label>
    <DatePicker
      id="inputDueDate"
      dateFormat="DD/MM/YYYY"
      locale={momentLocale}
      onChange={(val) => {
        const formatted = typeof val === "string" ? val : val.format("YYYY-MM-DD");
        onChange(formatted);
      }}
      value={value ? moment(value).format("DD/MM/YYYY") : ""}
      className="margin-0"
      timeFormat={false}
      inputProps={{ placeholder }}
    />
    {errorMessage ? <span className="form-control-feedback rioglyph rioglyph-error-sign"></span> : null}
    <span className="help-block">
      <span>{errorMessage}</span>
    </span>
  </div>
);

export default DueDateField;
